import { UtilityApiKeysConfiguration } from "../model/bps-admin/utility-api-keys";
import { apiSlice } from "../stores/base/api-slice";

// BPS admin only — both routes sit behind the gateway's BpsAdminPolicy. Each call names the
// utility, because the admin's own JWT tenant is not the one being configured.
const serviceBaseUrl = "/utilityconfigurations/api-keys";

const utilityApiKeysEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({
		getUtilityApiKeys: builder.query<UtilityApiKeysConfiguration, string>({
			query: utilityId => ({ url: serviceBaseUrl, params: { utilityId } }),
			providesTags: ["UtilityApiKeys"],
		}),
		saveUtilityApiKeys: builder.mutation<
			void,
			{ utilityId: string; configuration: UtilityApiKeysConfiguration }
		>({
			query: ({ utilityId, configuration }) => ({
				url: serviceBaseUrl,
				method: "PUT",
				body: { utilityId, ...configuration },
			}),
			invalidatesTags: ["UtilityApiKeys"],
		}),
	}),
});

export const { useGetUtilityApiKeysQuery, useSaveUtilityApiKeysMutation } = utilityApiKeysEndpoints;
